import React from 'react';

/**
 * @param {string[]} buttons
 * @param {{ [key: string]: React.ComponentType }} BUTTON_MAP
 */
export function createToolbarButtons(BUTTON_MAP, buttons, props) {
	return buttons.map(key => {
		if (key === 'spliter') {
			return key;
		}
		const Button = BUTTON_MAP[key];
		return <Button key={key} {...props} />
	}).filter(Boolean);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/createToolbarButtons.js